import React from 'react';

import { useTheme } from 'styled-components';

import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIcon } from 'components';
import { motion } from 'framer-motion';

import { styled } from 'third-party';

const Wrapper = styled(motion.div)`
  align-self: stretch;
  &:hover {
    cursor: pointer;
    background: rgba(28, 25, 23, 0.1);
  }
  padding: 10px 0;
  display: flex;
  gap: 0.2rem;
  flex-direction: column;
`;

const IconWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
`;

const StyledHeader = styled(motion.h5)<{ isactive: string }>`
  color: ${props =>
    props.isactive === 'true'
      ? props.theme.custom.palette.primary900
      : props.theme.custom.palette.muted500};

  text-align: center;
  font-size: 1.1rem;
  font-family: Source Sans Pro;
  font-weight: 600;
  line-height: 150%;
`;

type Props = {
  id: string;
  icon: string | (OverridableComponent<SvgIconTypeMap> & { muiName: string });
  isActive: boolean;
  caption: string;
  onClick: () => void;
};

const iconVariants = {
  initial: { scale: 1 },
  enlarge: {
    scale: 1.3,
  },
};

const titleVariants = {
  initial: { scale: 1 },
  enlarge: {
    scale: 1.1,
  },
};

const ICON_SIZE = '2.2rem';

export const MenuNavigationItem: React.FC<Props> = ({
  caption,
  id,
  icon: Icon,
  isActive,
  onClick,
}) => {
  const theme = useTheme();
  const iconColor = isActive
    ? theme.custom.palette.primary900
    : theme.custom.palette.muted500;
  return (
    <Wrapper
      id={id}
      onClick={onClick}
      initial={false}
      animate={isActive ? 'enlarge' : 'initial'}
      whileHover="enlarge"
    >
      <IconWrapper variants={iconVariants}>
        {typeof Icon === 'string' ? (
          <SvgIcon
            height={ICON_SIZE}
            icon={Icon}
            width={ICON_SIZE}
            color={iconColor}
          />
        ) : (
          <Icon
            style={{ height: ICON_SIZE, width: ICON_SIZE, color: iconColor }}
          />
        )}
      </IconWrapper>
      <StyledHeader variants={titleVariants} isactive={String(isActive)}>
        {caption}
      </StyledHeader>
    </Wrapper>
  );
};
